function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "SVGRepo_bgCarrier",
  strokeWidth: 0
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "SVGRepo_tracerCarrier",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgBackBtn = function SvgBackBtn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: "16px",
    width: "16px",
    id: "Layer_1",
    viewBox: "0 0 410.258 410.258",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "298.052,24 266.052,0 112.206,205.129 266.052,410.258 298.052,386.258 162.206,205.129 "
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBackBtn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back-btn.737e7d2c.svg";
export { ForwardRef as ReactComponent };